import type { SlideProps } from "@/engine/app/offsite-config";

export function Slide26Botschaft1(_: SlideProps) {
  return (
    <div className="deck-root dark slide-manifesto" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1">Botschaft 01</div>
        <h1 className="deck-title rise rise-2">
          Die Grundlage <br />
          <span className="accent">steht</span>
        </h1>
      </header>

      <div className="deck-big">
        <div className="big-statement rise rise-4">
          Was wir haben, gibt es bei den meisten Energievertrieben{" "}
          <span className="accent">unserer Größe nicht.</span>
        </div>
      </div>
    </div>
  );
}
